import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import "./ForgetPasswordStyle.css";

interface State {
  email: string;
  emailError: string;
  showPopup: boolean;
}

interface Actions {
  setEmail: (email: string) => void;
  onButtonClick: () => void;
  onButtonSendClick: () => void;
}

interface Props {
  state: State;
  actions: Actions;
}

const ForgetPasswordView: React.FC<Props> = ({ state, actions }) => {
  return (
    <div className="ja-forget-container">
      <div className="ja-forget-header">
        <h2>Passwort vergessen</h2>
        <p>Geben Sie Ihre E-Mail Adresse ein, um Ihr Passwort zurückzusetzen.</p>
      </div>

      <div className="ja-forget-form">
        <div className="ja-login-inputContainer">
          <label className="ja-login-label">E-Mail Adresse</label>
          <input
            type="email"
            value={state.email}
            placeholder="name@beispiel.de"
            onChange={(ev) => actions.setEmail(ev.target.value)}
            className="ja-login-inputBox"
          />
          {state.emailError && (
            <span className="ja-login-errorLabel">{state.emailError}</span>
          )}
        </div>

        <button
          type="button"
          className="ja-login-primaryButton"
          onClick={actions.onButtonClick}
        >
          Neues Passwort anfordern
        </button>
      </div>

      {/* Bestätigungs-Overlay direkt im Modal */}
      {state.showPopup && (
        <div className="ja-forget-successOverlay">
          <div className="ja-forget-successCard">
            <FontAwesomeIcon icon={faCheckCircle} className="ja-forget-successIcon" />
            <h3>E-Mail gesendet!</h3>
            <p>Ein neues Passwort wurde erfolgreich an Ihre E-Mail-Adresse versendet.</p>
            <button
              type="button"
              className="ja-login-primaryButton"
              onClick={actions.onButtonSendClick}
            >
              Fertig
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ForgetPasswordView;